import { render } from "./referReward.vue?vue&type=template&id=dbef2474"
import script from "./referReward.vue?vue&type=script&lang=js"
export * from "./referReward.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__